import React from "react";

import {
  Dialog,
  DialogContent,
  DialogOverlay,
} from "@replo/design-system/components/shadcn/core/dialog";

interface ImageOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  imageSrc: string;
  imageAlt: string;
}

export const ImageOverlay: React.FC<ImageOverlayProps> = ({
  isOpen,
  onClose,
  imageSrc,
  imageAlt,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogOverlay className="bg-black/70" />
      <DialogContent className="border-0 bg-transparent p-0 shadow-none max-w-none max-h-none w-auto h-auto">
        <div className="flex items-center justify-center max-h-[90vh] max-w-[90vw]">
          <img
            src={imageSrc}
            alt={imageAlt}
            className="max-h-full max-w-full object-contain rounded-lg"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
